import React from "react";

import { CHART_Y_TICK_INSET_PX, ChartAxisStyle } from "consts";

/** X axis props labelling every year, without axis or tick lines. */
export const yearXAxisProps = ({ fontSize, color }: ChartAxisStyle) => ({
  tick: { fontSize, fill: color },
  tickLine: false,
  axisLine: false,
  interval: 0,
});

type YAxisTickProps = { y?: number | string; payload?: { value?: unknown } };

/** Y axis ticks left-aligned at the shared inset, so they line up with the unit label above the plot. */
export const leftAlignedYAxisTick =
  ({ fontSize, color }: ChartAxisStyle, format: (value: number) => string) =>
  ({ y, payload }: YAxisTickProps) => (
    <text x={CHART_Y_TICK_INSET_PX} y={y} dy={4} fontSize={fontSize} fill={color} textAnchor="start">
      {format(Number(payload?.value ?? 0))}
    </text>
  );
